export default "assets/images/icons/instagram-d4f1fe1d.svg";